/* eslint-disable */
import {
  AudioPopupDefinition,
  AUDIO_POPUP,
  IMAGE_MAP2,
  VIDEO_POPUP,
  VideoPopupDefinition,
  VIDEO,
  VideoDefinition,
  ImageMap2Definition
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { t } from 'ttag';
import { isIOS, isSafari } from 'react-device-detect';

export const Interactive3: Translator = sequence => {
  let imageDimensions: { width: number; height: number; color?: string };

  return translate(sequence, item => {
    if (item.__typename === 'ImageMap') {
      const newItemPicture = sequence.items?.find(
        i => i.__typename === 'Background'
      );

      imageDimensions = {
        width:
          (item as any).pictures?.[0]?.width ??
          (newItemPicture as any)?.pictures?.[0]?.width ??
          1024,
        height:
          (item as any).pictures?.[0]?.height ??
          (newItemPicture as any)?.pictures?.[0]?.height ??
          1024,
        color: (newItemPicture as any)?.pictures?.[0]?.color || ''
      };

      return {
        type: IMAGE_MAP2,
        id: item.id,
        values: {
          imageUrl:
            (item as any).pictures?.[0]?.mediaUrl ||
            (newItemPicture as any)?.pictures?.[0]?.mediaUrl,
          body: t`Click the icons to continue.`,
          isFullScreen: true,
          color: imageDimensions.color || ''
        },
        items: (item.items || []).map((i, index) => {
          const initialParts = (i.coordinates || '').split(',');
          const parts: string[] = [
            (
              (Number(initialParts[0]) * 100) /
              imageDimensions.width
            ).toString(),
            (
              (Number(initialParts[1]) * 100) /
              imageDimensions.height
            ).toString()
          ];

          // Handle dynamically added popup items (our new audio points)
          // Process any POPUP item that has coordinates (regardless of audio)
          if (
            ((i as any).type === 'POPUP' || (i as any).type === 'AudioPopup') &&
            ((i.coordinates && i.coordinates !== 'null') ||
              ((i as any).values?.left !== undefined &&
                (i as any).values?.left !== null) ||
              ((i as any).values?.top !== undefined &&
                (i as any).values?.top !== null))
          ) {
            // Handle coordinates from different sources
            let leftPercent = 0;
            let topPercent = 0;
            const coordinates =
              i?.coordinates || (i as any)?.settings?.coordinates || '';
            if ((i as any).type === 'AudioPopup' && (i as any).values) {
              // For frontend AudioPopup items, coordinates are already in percentages
              leftPercent = parseFloat((i as any).values.left) || 0;
              topPercent = parseFloat((i as any).values.top) || 0;
            } else {
              // For backend POPUP items, convert from absolute pixels to percentage
              const coordParts = coordinates.split(',');

              // Ensure we have valid dimensions to avoid NaN
              // Use consistent dimensions with ImageMap2 (1024x1024)
              const safeWidth = imageDimensions.width ?? 1024;
              const safeHeight = imageDimensions.height ?? 1024;

              // Parse coordinates safely
              const xCoord = coordParts[0] ? Number(coordParts[0]) : 0;
              const yCoord = coordParts[1] ? Number(coordParts[1]) : 0;

              leftPercent =
                !isNaN(xCoord) && safeWidth > 0
                  ? (xCoord * 100) / safeWidth
                  : 0;
              topPercent =
                !isNaN(yCoord) && safeHeight > 0
                  ? (yCoord * 100) / safeHeight
                  : 0;
            }

            const audioPopupData = {
              type: AUDIO_POPUP,
              id: (i as any).id || `${item.id}-${index}`, // Use real subitem ID if available
              items: [],
              values: {
                // Match original behavior: show number only when variant is 'number'
                title:
                  item.variant === 'number'
                    ? i.title || (i as any).values?.title || index + 1
                    : null,
                left: leftPercent,
                top: topPercent,
                name: i.title || (i as any).values?.name || '',
                body: i.body || (i as any).values?.body || '',
                mediaUrl:
                  i.audios?.[0]?.mediaUrl || (i as any).values?.mediaUrl || '',
                subtitlesUrl:
                  i.audios?.[0]?.subtitlesUrl ||
                  (i as any).values?.subtitlesUrl ||
                  '',
                blocking: true,
                replay: true,
                isPopupCentered: true,
                scroll: false,
                pixelCoordinates: coordinates
              }
            } as AudioPopupDefinition;

            return audioPopupData;
          } else if (i.videos && i.videos.length > 0) {
            const firstVideo = i.videos[0];
            return {
              type: VIDEO_POPUP,
              id: `${item.id}-${index}`,
              items: [
                {
                  type: VIDEO,
                  id: `${item.id}-video`,
                  values: {
                    videoContainerStyles: {
                      width: '80%',
                      height: '70%',
                      borderRadius: '20px'
                    },
                    blocking: true,
                    isolated: false,
                    showPlayButton: true,
                    autoPlay: true,
                    mediaUrl:
                      isIOS || isSafari
                        ? ([
                            firstVideo?.mediaUrl && {
                              src: firstVideo.mediaUrl,
                              type: 'video/mp4'
                            }
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          ].filter(Boolean) as any)
                        : ([
                            firstVideo?.hlsUrl && {
                              src: firstVideo.hlsUrl,
                              type: 'application/vnd.apple.mpegurl'
                            },
                            firstVideo?.mediaUrl && {
                              src: firstVideo.mediaUrl,
                              type: 'video/mp4'
                            }
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          ].filter(Boolean) as any),
                    subtitlesUrl: firstVideo?.subtitlesUrl || '',
                    snapshotUrl: firstVideo?.snapshotUrl || ''
                  }
                } as VideoDefinition
              ],
              values: {
                title: item.variant == 'number' ? index + 1 : null,
                left: parts[0] && parseInt(parts[0]),
                top: parts[1] && parseInt(parts[1]),
                mediaUrl: i.videos?.[0]?.mediaUrl,
                subtitlesUrl: i.videos?.[0]?.subtitlesUrl,
                snapshotUrl: i.videos?.[0]?.snapshotUrl,
                blocking: true,
                replay: true
              }
            } as VideoPopupDefinition;
          } else {
            let titleForPopup = `${index + 1}`;

            if (initialParts[2]) {
              titleForPopup = initialParts[2];
            }

            return {
              type: AUDIO_POPUP,
              id: (i as any).id || `${item.id}-${index}`, // Use real subitem ID if available
              items: [],
              values: {
                title: item.variant == 'number' ? titleForPopup : null,
                left: parts[0] && parseInt(parts[0]),
                top: parts[1] && parseInt(parts[1]),
                name: i.title,
                body: i.body,
                mediaUrl: i.audios?.[0]?.mediaUrl,
                subtitlesUrl: i.audios?.[0]?.subtitlesUrl,
                blocking: true,
                replay: true,
                isPopupCentered: true,
                scroll: true,
                pixelCoordinates:
                  i?.coordinates || (i as any)?.settings?.coordinates || ''
              }
            } as AudioPopupDefinition;
          }
        })
      } as ImageMap2Definition;
    }
    return null;
  });
};
